import { ContactComponent } from "./contact.component";
import { Routes, RouterModule } from "@angular/router";

export const ContactRoutes: Routes = [
  {
    path: "contact",
    component: ContactComponent
  }
];
